import React from "react";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../Breadcrumbs";
import SidebarToggleButton from "../../layout/SidebarToggleButton";

export default function PatientModuleHeader({
    pages,
    onToggleSidebar,
    mobileBackTo = "/patients",
    mobileBackLabel = "Pacientes",
    mobileTitle,
    actions,
}) {
    return (
        <div className="sticky top-0 z-20 border-b border-slate-200 bg-white/95 backdrop-blur dark:border-slate-800 dark:bg-slate-950/90">
            <div className="flex min-h-[72px] items-center gap-3 px-4 py-3 lg:px-6">
                <SidebarToggleButton onClick={onToggleSidebar} />

                <div className="min-w-0 flex-1">
                    <Link
                        to={mobileBackTo}
                        className="inline-flex items-center gap-1 text-sm font-medium text-slate-500 transition hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-100 lg:hidden"
                    >
                        <ChevronLeftIcon className="h-4 w-4" />
                        <span className="truncate">
                            {mobileTitle || mobileBackLabel}
                        </span>
                    </Link>
                    <div className="hidden lg:block">
                        <Breadcrumbs pages={pages} />
                    </div>
                </div>

                {actions ? (
                    <div className="ml-auto flex shrink-0 items-center gap-2">
                        {actions}
                    </div>
                ) : null}
            </div>
        </div>
    );
}
